import { render } from "./RCheckbox.vue?vue&type=template&id=1ffe056e"
import script from "./RCheckbox.vue?vue&type=script&lang=js"
export * from "./RCheckbox.vue?vue&type=script&lang=js"

import "./RCheckbox.vue?vue&type=style&index=0&id=1ffe056e&lang=css"
script.render = render

export default script